import React from 'react';
import { useTheme } from '@mui/material/styles';
import {
  MenuItem,
  Select,
  Typography,
  Box,
  Checkbox,
  ListItemText,
} from '@mui/material';
import chevronDown from 'assets/icons/select-chevron-down.svg';
import chevronUp from 'assets/icons/select-chevron-up.svg';

const SelectInput = ({
  id,
  placeholder,
  open,
  handleOpen,
  handleClose,
  handleChange,
  topMargin,
  options,
  multiple = false,
  value,
  ...rest
}) => {
  const theme = useTheme();

  return (
    <Select
      fullWidth
      labelId={id}
      id={id}
      multiple={multiple}
      value={value}
      onOpen={() => handleOpen(id)}
      onClose={() => handleClose(id)}
      onChange={handleChange}
      displayEmpty
      renderValue={(selected) => {
        if (multiple) {
          if (!selected || selected.length === 0) {
            return (
              <Typography variant="body3" color={theme.palette.darkGrey[500]}>
                {placeholder}
              </Typography>
            );
          }
          return (
            <Typography variant="body3" color={theme.palette.darkGrey[500]}>
              {selected.join(', ')}
            </Typography>
          );
        }

        const selectedOption = options.find(
          (option) => option.value === selected,
        );
        return selectedOption ? (
          <Typography variant="body3" color={theme.palette.darkGrey[500]}>
            {selectedOption.label}
          </Typography>
        ) : (
          <Typography variant="body3" color={theme.palette.darkGrey[500]}>
            {placeholder}
          </Typography>
        );
      }}
      IconComponent={() => (
        <Box
          component={'img'}
          src={open[id] ? chevronUp : chevronDown}
          sx={{ mr: '14px' }}
          alt="select arrow"
        />
      )}
      size="small"
      sx={{
        height: '44px',
        mt: topMargin ? topMargin : '0px',
      }}
      aria-label={id}
      {...rest}
    >
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {multiple ? (
            <>
              <Checkbox checked={value.includes(option.value)} />
              <ListItemText primary={option.label} />
            </>
          ) : (
            <Typography
              variant="body3"
              color={theme.palette.darkGrey[900]}
              fontWeight={500}
            >
              {option.label}
            </Typography>
          )}
        </MenuItem>
      ))}
    </Select>
  );
};

export default SelectInput;
